import { NextPayments } from '@hub/shared'
import { useEffect, useLayoutEffect, useState } from 'react'
import { useNavigate } from 'react-router'
import './payment-shortcut.component.scoped.scss'

interface Props {
  onSetShowNextPayments?: (showNextPayments: boolean) => void
  disableTip?: boolean
}

export default ({ onSetShowNextPayments, disableTip = false }: Props) => {
  const [paymentsReceived, setPaymentsReceived] = useState(true)
  const [width, setWidth] = useState(window.innerWidth)
  const navigate = useNavigate()

  useEffect(() => {
    if (onSetShowNextPayments && typeof onSetShowNextPayments === 'function') {
      onSetShowNextPayments(paymentsReceived)
    }
  }, [paymentsReceived, onSetShowNextPayments])

  useLayoutEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth)
    }
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  })

  return !paymentsReceived ? null : (
    <div className="payment-shortcut display-flex justify-content-space-between">
      <NextPayments
        onNavigateTo={(path: string) => navigate(path)}
        onPaymentsReceived={(paymentsReceived: boolean) => setPaymentsReceived(paymentsReceived)}
        showIcon
        disableTip={disableTip}
        showCalendar={width > 370}
      />
    </div>
  )
}
